import { mockedMetricsUtilsDataSource } from "gather-client-common/dist/src/public/metrics/MetricsUtilsDataSource";
import { metricsUtilsDataSource } from "./MetricsUtilsDataSource";
import { logMetricsEventToNewRelic } from "./newrelic";
import { getMetricsUtils } from "gather-client-common/dist/src/public/metrics/utils";
import { switchEnv } from "gather-env-config/dist/src/public/env";
const metricsDataSource = switchEnv({
    test: () => mockedMetricsUtilsDataSource,
    dev: () => metricsUtilsDataSource,
    local: () => metricsUtilsDataSource,
    staging: () => metricsUtilsDataSource,
    prod: () => metricsUtilsDataSource,
});
const { amplitudeIdentify, amplitudeGroupIdentify, updateRevenueUserProperty, logMetricsEvent: logMetricsEventSkippingNewRelic, logSignInEvent, setUserInfo, } = getMetricsUtils(metricsDataSource);
const logMetricsEvent = async (...args) => {
    logMetricsEventToNewRelic(args[0], args[1]);
    await logMetricsEventSkippingNewRelic(...args);
};
export { amplitudeIdentify, amplitudeGroupIdentify, updateRevenueUserProperty, logMetricsEvent, logMetricsEventSkippingNewRelic, logSignInEvent, setUserInfo, };
//# sourceMappingURL=utils.js.map